import { html, useEffect, useState } from '/vendor/htm-preact.module.js';
import { get } from '/api.js';

/**
 * Following a match from a QR by the table.
 *
 * Read-only by design: the tablet scores, which is what removes concurrent
 * writes and the offline reconciliation that would come with three devices
 * editing one frame.
 *
 * Polling rather than server-sent events. SSE would want a per-match
 * subscriber registry in a single-process app, hold a connection open through
 * the proxy, and have to be reasoned about every time a cellar drops the
 * signal — which is often. A question every two seconds is nothing, and it
 * degrades to a stale screen rather than a broken one.
 */
const EVERY_MS = 2000;

export function WatchScreen({ token }) {
  const [match, setMatch] = useState(null);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    let live = true;
    async function tick() {
      try {
        const next = await get(`/api/watch/${encodeURIComponent(token)}`);
        if (live) { setMatch(next); setGone(false); }
      } catch (e) {
        // 404 means the match ended, or the link was never good. Either way
        // there is nothing more to show and nothing to retry into.
        if (live && e.status === 404) setGone(true);
      }
    }
    tick();
    const timer = setInterval(tick, EVERY_MS);
    return () => { live = false; clearInterval(timer); };
  }, [token]);

  if (gone) {
    return html`<div class="card" data-testid="watch-over">
      <p>That match has finished.</p>
    </div>`;
  }
  if (match === null) return html`<p class="sub">Loading…</p>`;

  return html`
    <div data-testid="watch">
      <p class="sub">Watching · ${match.game_format} · race to ${match.race_to}</p>
      ${match.players.map((p) => html`
        <div key=${p.user_id} class="card rowbetween"
             data-testid=${`watch-player-${p.user_id}`}>
          <span>${p.name}</span>
          <span data-testid="watch-frames">${p.frames}</span>
        </div>`)}
      <p class="sub">Scored on the table's own device.</p>
    </div>`;
}
